export default __webpack_public_path__ + "static/media/newborn.50c577e2.png";